import React, { useState } from "react";
import logo from "./../../../../shared/images/c2s-logo-white.png";
import { auth } from "../../../../shared/services/firebase";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

import {
  Container,
  CustomLink as Link,
  Logo,
  Input,
  CustomButton as Button,
  CustomTypography as Typography,
  Form,
} from "./styles";


export const PasswordRecovery = function () {
  
  const alertMessageSuccess = (email) =>{
    return toast.success(t("PasswordRecoveryScreen:recovery_alert", {email}))
  };

  const { t } = useTranslation(["PasswordRecoveryScreen", "common"]);
  const handleSubmit = (values) => {
    auth
      .sendPasswordResetEmail(values.email)
      .then(() => alertMessageSuccess(values.email))
      .catch(() => {
        toast.error(t("PasswordRecoveryScreen:errorMessage"));
      });
  };

  const formikSettings = {
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(t("common:errors.invalid"))
        .min(4, t("common:errors.too_short.other", { count: 4 }))
        .required(t("common:errors.required")),
    }),
  };

  return (
    <Container>
      <Formik
        {...formikSettings}
        validate={(values) => {
          const errors = {};
          if (!values.email) {
            errors.email = t("common:errors.required");
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = t("common:errors.invalid");
          }
          return errors;
        }}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, errors, handleSubmit }) => (
          <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <Logo src={logo} alt="Logo C2S" />
            <Input
              id="email"
              label={t("label.email")}
              variant="filled"
              name="email"
              type="email"
              value={values.email}
              helperText={errors.email}
              onChange={handleChange}
            />
            <Button variant="contained" color="default" type="submit">
              {t("PasswordRecoveryScreen:submit")}
            </Button>
            <Link to="/authentication">
              {t("PasswordRecoveryScreen:goBack")}
            </Link>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
